export const appThreeDotsIcon = {
    data: `<svg viewBox="0 0 10 3" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.5" width="2" height="2" fill="#E0E0E0"/><rect x="4" y="0.5" width="2" height="2" fill="#E0E0E0"/><rect x="8" y="0.5" width="2" height="2" fill="#E0E0E0"/></svg>`,
    name: 'three-dots'
};